<template>
  <div>
    <div class="check-part">
      <div class="check-lf-box">
        <van-checkbox
          v-model="infoChecked"
          checked-color="#EA332B"
          icon-size="20px"
          @change="clauseCheck"
        />
      </div>
      <div class="check-text">
        我已阅读并同意
        <a @click.stop="xuzhishengming('YHSQS')"
          >《投保须知、被保险人声明及购买人声明》</a
        >
        <a @click.stop="xuzhishengming('KHGZS')">《客户告知书》</a>
        <a @click.stop="xuzhishengming('SQSMCNS')"
          >《授权申明、信息安全及保密承诺书》</a
        >
        <a @click.stop="xuzhishengming('YHXYS')">《用户协议》</a>
        <a @click.stop="xuzhishengming('BXTK-KPJJ')">《保险条款》</a>
        <a @click.stop="xuzhishengming('LPXZJZY')">《理赔须知》</a>
        <a @click.stop="xuzhishengming('GKFWSC')">《健康管理服务手册》</a>
        <a @click.stop="xuzhishengming('CPSMS')">《产品说明书》</a>
        <a @click.stop="xuzhishengming('YBGRL')"
          >《医保个人历年结余账户支付授权书》</a
        >
      </div>
    </div>
    <pdf-action-sheet
      v-model="showTouBaoShengMing"
      :style-obj="{ height: '70%' }"
      :title="name"
    >
      <div class="tiaokuancss" v-html="contenthtml"></div>
    </pdf-action-sheet>
    <van-popup
      class="closeckfather"
      v-model="tanshow"
      round
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height: '80%' }"
    >
      <van-tabs line-width="33%" v-model="tabVal" @click="returnClick">
        <van-tab
          class="rollstyle"
          v-for="(item, index) in bqlabel"
          :key="index"
          :title="item"
        />
      </van-tabs>
      <div class="contentstyle" v-html="contenthtml1"></div>
      <div class="testWrap">
        <van-button
          id="Agree_Terms"
          :disabled="disabledval"
          @click="wseccuss"
          class="testBtn"
          >我已阅读并确认勾选协议<span v-show="disabledval">
            ({{ times }}S)</span
          ></van-button
        >
      </div>
    </van-popup>
  </div>
</template>
<script>
  import { axiosclause } from '@/api/company-appointment'
  import { gethttpurl } from '@/util/tools'
  import PdfActionSheet from '@/views/PdfFiles/PdfActionSheet'
  export default {
    data() {
      return {
        name: '',
        contenthtml: '',
        contenthtml1: '',
        tabVal: 0,
        times: 3,
        disabledval: false,
        tanshow: false,
        showTouBaoShengMing: false,
        bqlabel: [
          '《投保须知、被保险人声明及购买人声明》',
          '《客户告知书》',
          '《授权申明、信息安全及保密承诺书》',
          '《用户协议》',
          '《保险条款》',
          '《理赔须知》',
          '《健康管理服务手册》',
          '《产品说明书》',
          '《医保个人历年结余账户支付授权书》'
        ],
        parameter: [
          'YHSQS',
          'KHGZS',
          'SQSMCNS',
          'YHXYS',
          'BXTK-KPJJ',
          'LPXZJZY',
          'GKFWSC',
          'CPSMS',
          'YBGRL'
        ],
        infoChecked: false
      }
    },
    props: {
      baoxiancode: {
        type: String,
        default: ''
      },
      fromSourceCode: {
        type: String,
        default: ''
      },
      xfzIndex: {
        type: Object,
        default: () => {}
      }
    },
    components: {
      PdfActionSheet
    },
    mounted() {},
    methods: {
      async xuzhishengming(e) {
        this.name = ''
        this.contenthtml = ''
        this.showTouBaoShengMing = true
        const res = await axiosclause({
          goodsCode: this.baoxiancode,
          code:
            gethttpurl('fromSourceCode') !== 'yxhb00000317'
              ? `${this.baoxiancode}-${e}`
              : `${this.baoxiancode}-${e}-HD`
        })
        this.name = res.name
        this.contenthtml = res.content
      },
      clauseCheck() {
        if (this.xfzIndex?.xfzIndex === 0) {
          this.infoChecked = false
          this.$emit('clauseck', this.infoChecked, true)
          return false
        }
        if (this.infoChecked) {
          this.tanshow = true
          this.tabVal = 0
          this.returnClick()
        }
        this.$emit('clauseck', this.infoChecked, false)
      },
      wseccuss() {
        this.tanshow = false
      },
      async returnClick() {
        this.contenthtml1 = ''
        const res = await axiosclause({
          goodsCode: this.baoxiancode,
          code:
            gethttpurl('fromSourceCode') == 'yxhb00000317' &&
            this.parameter[this.tabVal] == 'KHGZS'
              ? `${this.baoxiancode}-${this.parameter[this.tabVal]}-HD`
              : `${this.baoxiancode}-${this.parameter[this.tabVal]}`
        })
        this.contenthtml1 = res.content
      }
    }
  }
</script>
<style lang="scss" scoped>
  .check-part {
    display: flex;
    background: #ffffff;
    margin-bottom: xvw(20);
    .check-lf-box {
      padding: 10px;
    }
    .check-text {
      padding: 10px;
      font-size: 12px;
      line-height: 18px;
      color: #9a9a9a;
      a {
        color: #5675f1;
        cursor: pointer;
      }
    }
  }
  .tiaokuancss {
    font-size: 14px;
    line-height: 20px;
    padding: 0 xvw(30);
  }
  .contentstyle {
    height: 80%;
    font-size: 14px;
    line-height: 20px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px xvw(30);
    /deep/table {
      table-layout: fixed;
      border-collapse: collapse;
      width: 100%;
      text-align: center;
      border-color: #ff9695;
      color: #333333;
      font-size: 12px;
      td {
        width: auto;
        border-top: 1px solid #ff9695 !important;
        border-right: 1px solid #ff9695 !important;
        border-bottom: 1px solid #ff9695 !important;
        border-left: 1px solid #ff9695 !important;
        p {
          word-break: break-all !important;
          white-space: pre-wrap;
        }
      }
      tr:not([tableHead]) {
        td:first-child {
          width: 60px;
        }
        td:last-child {
          width: 120px;
        }
      }
      .firstRow {
        height: xvw(100);
        background: #ffeded;
      }
    }
  }
  /deep/table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    text-align: center;
    border-color: #ff9695;
    color: #333333;
    font-size: 12px;
    td {
      width: auto;
      border-top: 1px solid #ff9695 !important;
      border-right: 1px solid #ff9695 !important;
      border-bottom: 1px solid #ff9695 !important;
      border-left: 1px solid #ff9695 !important;
      p {
        word-break: break-all !important;
        white-space: pre-wrap;
      }
    }
    tr:not([tableHead]) {
      td:first-child {
        width: 60px;
      }
      td:last-child {
        width: 120px;
      }
    }
    .firstRow {
      height: xvw(100);
      background: #ffeded;
    }
  }
  /deep/ .pop-content {
    img {
      width: 100%;
      display: block;
    }
  }
  .testWrap {
    padding: 10px 0;
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #fff;
  }
  .testBtn {
    display: block;
    width: pxrem(610);
    height: pxrem(101);
    background: linear-gradient(135deg, #ff7828 0%, #ff282c 100%);
    border-radius: 60px;
    background-size: 100%;
    margin: 0 auto;
    font-size: pxrem(32) !important;
    font-weight: bold;
    color: #ffffff;
    line-height: 48px;
    text-shadow: 0px 1px 2px #e64b10;
  }
</style>
